import { useEffect } from "react";
import { generateStaticPieNode } from "../../graph-util";
import { calculatePieChunks } from "../../utils";
import { CreateControlNodeOnlyFn, ItemWithClassification } from "../../@types";
import { NetworkRepEntry } from "../../../network/@types/Url";

interface Props {
  data: NetworkRepEntry[] | undefined;
  renderer: CreateControlNodeOnlyFn;
  counts: number;
}
const useRenderNetworkReferences = ({
  data: networkRepData,
  renderer: createControlNodeFromData,
  counts: totalCount
}: Props) => {
  useEffect(() => {
    if (!networkRepData || !totalCount) return;
    createControlNodeFromData({
      generateControlNode: () =>
        generateStaticPieNode({
          id: "networkReferencesNode",
          label: "Network References",
          points: calculatePieChunks(
            networkRepData as ItemWithClassification[],
            (item: ItemWithClassification) => item.classification
          ),
          radius: 70,
          total: totalCount
        })
    });
  }, [createControlNodeFromData, networkRepData, totalCount]);
};

export default useRenderNetworkReferences;
